/* eslint import/prefer-default-export: 0 */

export {
  AccountTemplate,
  AccountRegisterTemplate,
  AccountMyPageTemplate,
  AccountTwoColumnTemplate,
} from '../components/Templates/Account';

export type {
  AccountTemplateProps,
  AccountRegisterTemplateProps,
  AccountMyPageTemplateProps,
  AccountTwoColumnTemplateProps,
} from '../components/Templates/Account';

export {
  CancelMembershipApplyContents,
  CancelMembershipConfirmContents,
} from '../components/Contents/Account/CancelMembership';

export type {
  CancelMembershipApplyContentsProps,
  CancelMembershipConfirmContentsProps,
} from '../components/Contents/Account/CancelMembership';

export { CompleteContents } from '../components/Contents/Account/Complete';

export type { CompleteContentsProps } from '../components/Contents/Account/Complete';

export {
  EmailAlterationApplyContents,
  EmailAlterationSendMailContents,
} from '../components/Contents/Account/EmailAlteration';

export type {
  EmailAlterationApplyContentsProps,
  EmailAlterationInvalidParam,
  EmailAlterationSendMailContentsProps,
} from '../components/Contents/Account/EmailAlteration';

export { InitialSettingsContents } from '../components/Contents/Account/InitialSettings';

export type {
  InitialSettingsContentsProps,
  InitialSettingsInvalidParam,
  InitialSettingsInvalidParams,
} from '../components/Contents/Account/InitialSettings';

export { LoginContents } from '../components/Contents/Account/Login';

export type { LoginContentsProps } from '../components/Contents/Account/Login';

export { MailMagazineSettingContents } from '../components/Contents/Account/MailMagazineSetting';

export type { MailMagazineSettingContentsProps } from '../components/Contents/Account/MailMagazineSetting';

export { MyPageContents } from './Contents/Account/MyPage';

export type { MyPageContentsProps } from './Contents/Account/MyPage';

export {
  PasswordResetApplyContents,
  PasswordResetChangeContents,
} from '../components/Contents/Account/PasswordReset';

export type {
  PasswordResetApplyContentsProps,
  PasswordResetChangeContentsProps,
  PasswordResetInvalidParam,
  PasswordResetInvalidParams,
  PasswordResetChangeInvalidParam,
  PasswordResetChangeInvalidParams,
} from '../components/Contents/Account/PasswordReset';

export { ProfileSettingContents } from '../components/Contents/Account/ProfileSetting';

export type {
  InitBasicInfo,
  MarriageStatusId,
  HasChildrenId,
  ProfileSettingContentsProps,
  ProfileSettingInvalidParam,
  ProfileSettingInvalidParams,
  NameValidator,
  PreferredUsernameValidator,
  PhoneNumberValidator,
  PostalCodeValidator,
  AddressValidator,
  FetchAddressByPostalCode,
  NameUpdaterRequest,
  PreferredUsernameUpdaterRequest,
  GenderUpdaterRequest,
  PhoneNumberUpdaterRequest,
  AddressUpdaterRequest,
  FamilyStructureUpdaterRequest,
  BirthdateUpdaterRequest,
  ProfileUpdaterRequest,
  BasicInfoUpdaters,
  ProfileValidator,
  QualificationCodeListValidator,
  EmploymentIdValidator,
  AffiliationIdsValidator,
  ActivityAreaIdsValidator,
  LicenseIdsValidator,
  CustomLicenseValidator,
  NurseLicenseNumberValidator,
  QualificationCodeListUpdaterRequest,
  EmploymentIdUpdaterRequest,
  AffiliationIdsUpdaterRequest,
  ActivityAreaIdsUpdaterRequest,
  LicenseIdsUpdaterRequest,
  CustomLicenseUpdaterRequest,
  NurseLicenseNumberUpdaterRequest,
  QualificationsAndWorkUpdaters,
  InitQualificationsAndWork,
  SchoolValidator,
  AcademicBackgroundUpdaters,
  SchoolUpdaterRequest,
  ScholarshipUpdaterRequest,
  InitAcademicBackground,
  ScholarshipValidator,
} from '../components/Contents/Account/ProfileSetting';

export { RegisterContents } from '../components/Contents/Account/Register';

export type {
  RegisterContentsProps,
  RegisterInvalidParam,
  RegisterInvalidParams,
} from '../components/Contents/Account/Register';

export type {
  LoginInvalidParam,
  LoginInvalidParams,
} from '../components/Form/FormBlock/FormBlockLogin/FormBlockLogin';

export { ErrorReturnContents } from '../components/Contents/Error/ErrorReturnContents';

export { GoogleTagManager, type GoogleTagManagerId } from './GoogleTagManager';
export { GoogleAdManager } from './GoogleAdManager';
export { GoogleAdManagerSlot } from './GoogleAdManagerSlot';

// TODO 以下は動作確認の為に追加した物です、不要になったら削除する
export { Sample } from './Sample';
